import { AppPlatform } from 'modules/mobileApps/types';
import { Moment } from 'moment';
import { colors, fontSizes } from 'ui/theme';
import { CIRCLE, DIAMOND, DOWN_TRIANGLE, SQUARE, UP_TRIANGLE } from './constants';

export const CONVERSION_COLORS = [
  colors.salmon50,
  colors.mustard50,
  colors.cyan50,
  colors.purple90,
  colors.green50,
  colors.tangerine100,
  colors.forest100,
  colors.cyan100,
  colors.purple50,
  colors.flamingo100,
  colors.cottoncandy100,
  colors.lime100,
] as const;

export const CONVERSION_SHAPES = [CIRCLE, DIAMOND, SQUARE, UP_TRIANGLE, DOWN_TRIANGLE] as const;

export type ShapeTypes = (typeof CONVERSION_SHAPES)[number];

export type ShapeSizeType = {
  [K in ShapeTypes]: string;
};

export const CONVERSION_SHAPE_SIZES: ShapeSizeType = {
  [CIRCLE]: fontSizes.s16,
  [DIAMOND]: fontSizes.s16,
  [SQUARE]: fontSizes.s14,
  [UP_TRIANGLE]: fontSizes.s12,
  [DOWN_TRIANGLE]: fontSizes.s12,
};

export interface Histogram {
  /** Dictionary of metrics over time */
  buckets: Array<{ time: number; value: number }>;
}

export interface ConversionEventMetricType {
  /** The name of the conversion event */
  eventName: string;
  /** The value of the conversion event */
  eventValue: number;
  /** The plot color of the conversion event */
  color: string;
  /** The plot shape of the conversion event */
  shape: ShapeTypes;
  /** Max value of the metric over the timeseries */
  maxEventValueOverTime: number;
  /** Conversion metric over time */
  histogram: Histogram;
}

export interface LocalConversionEventStateType extends ConversionEventMetricType {
  /** Is the conversion metric selected to be ploted */
  selected: boolean;
}

export type Destination = {
  color: string;
  percentage: number;
  value: number;
  appName: string;
  platform: AppPlatform;
};

export type Label = {
  id: string;
  name: string;
};

export type DateParams = {
  startTime?: Moment;
  endTime?: Moment;
};

export type PieChartData = {
  y: number;
  name: string;
}[];

export type Segment = undefined | { name?: string; type?: string };

export enum ViewState {
  Loading,
  NoData,
  ContentReady,
}

export type CampaignRepliesOverviewResultsDefinition = {
  totalReplies: number;
  totalQuickReplies: number;
  totalCustomReplies: number;
};
